import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontMedium, ZeeFontRegular } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

export const BannerWrapper = styled.div`
  gap: 20px;
  width: 224px;
  margin: auto;
  margin-top: 10%;
  ${flex('column', '')}
  ${MQ.MediaSm} {
    width: 252px;
  }
  ${MQ.MediaMd} {
    width: 284px;
    margin-top: 14%;
  }
  ${MQ.MediaLg} {
    width: 252px;
    margin-top: 45%;
  }
  ${MQ.MediaXl} {
    gap: 24px;
    width: 269px;
  }
`;

export const Text = styled.span`
  color: ${colors.white};
  text-align: center;
  ${ZeeFontRegular(12, 17)}
  ${MQ.MediaSm} {
    ${ZeeFontMedium(14, 20)}
  }
  ${MQ.MediaMd} {
    ${ZeeFontMedium(16, 22)}
  }
  ${MQ.MediaLg} {
    ${ZeeFontMedium(14, 20)}
  }
  ${MQ.MediaXl} {
    ${ZeeFontMedium(16, 22)}
  }
`;

export const explore = css`
  height: 32px;
  min-width: 109px;
  max-width: 125px;
  padding: 4px 10px;
  background: ${colors.PurpleBtn};
  color: ${colors.PrimaryWhiteColor};
  ${ZeeFontMedium(12, 18)};
  ${MQ.MediaSm} {
    height: 38px;
    width: 120px;
    padding: 8px 10px;
    ${ZeeFontRegular(14, 22)};
  }
  ${MQ.MediaMd} {
    height: 48px;
    width: 150px;
    padding: 12px 18px;
    ${ZeeFontMedium(16, 22)};
  }
  ${MQ.MediaLg} {
    height: 32px;
    width: 109px;
    padding: 4px 10px;
    ${ZeeFontMedium(12, 18)};
  }
  ${MQ.MediaXl} {
    height: 48px;
    width: 148px;
    padding: 12px 18px;
    ${ZeeFontBold(16, 22)};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &:hover {
    color: ${colors.PrimaryWhiteColor};
    border: none;
    background: ${colors.PurpleBtnHover};
    transition: background-color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  }
`;
